import Icon from '../components/Icon.vue'

Icon.register({
  grimace: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM144 400v-40h-40v8c0 17.7 14.3 32 32 32h8zM144 344v-40h-8c-17.7 0-32 14.3-32 32v8h40zM136 208c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zM208 400v-40h-48v40h48zM208 344v-40h-48v40h48zM272 400v-40h-48v40h48zM272 344v-40h-48v40h48zM336 400v-40h-48v40h48zM336 344v-40h-48v40h48zM328 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM392 368v-8h-40v40h8c17.7 0 32-14.3 32-32zM392 344v-8c0-17.7-14.3-32-32-32h-8v40h40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grimace.js
// module id = 1398
// module chunks = 0